import styled from "styled-components";

export const GameClubCalendarWrapper = styled.div`
  position: fixed;
  top: 0px;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
`;

export const GameClubCalendarContent = styled.div`
  position: fixed;
  width: 308px;

  border: 1px solid transparent;

  border-radius: 12px;
  background-image: linear-gradient(#000, #000),
    linear-gradient(
      to right,
      #ba643a 25%,
      #ffffff 50%,
      #7addeb 75%,
      #836623 100%
    );
  background-origin: border-box;
  background-clip: content-box, border-box;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const GameClubCalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 16px 15px;
  color: #fff;

  .title {
    color: #fff;
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.36px;
  }
`;

export const GameClubCalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #fff;
  padding-bottom: 28px;
`;

export const GameClubCalendarButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  gap: 8px;
  padding: 0px 16px;
`;

export const GameClubCalendarButton = styled.div<{
  backgroundColor: string;
  color: string;
}>`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.backgroundColor};
  height: 48px;
  border-radius: 8px;
  color: ${(props) => props.color};
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
`;
export const GameClubCalendarTop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding: 0 16px;

  .calendar-header {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    width: 100%;

    .nav-button {
      height: 15px;
      background: none;
      border: none;
      font-size: 15px;
      color: #fff;
      cursor: pointer;

      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }

    .month-year {
      color: #fff;
      font-family: Pretendard;
      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;

export const GameClubCalendarWeekdays = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  padding: 8.69px 14.484px;
  color: #fff;

  .weekday {
    text-align: center;
    color: #fff;
    font-family: Pretendard;
    font-size: 11.587px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const GameClubCalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  padding: 0 16px;
  color: #a6a6a6;

  .day {
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
    border-radius: 50px;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    &.start-date {
      background: #6436e7;
      color: white;
      font-weight: 600;
    }

    &.end-date {
      background: #6436e7;
      color: white;
      font-weight: 600;
    }

    &.in-range {
      background: rgba(100, 54, 231, 0.3);
      color: white;
    }

    &.today {
      border: 2px solid #fff;
    }
  }

  .empty {
    aspect-ratio: 1;
  }
`;
